<template>
    <div class="sport" :class="[{active: getActive},{default: !getActive}, element.color]" @click="changeFilter()">{{ element.ru }}</div>
</template>
<script>
export default {
    name: 'ElementSport',
    data: () => {
      return {
        active: null
      }
    },
    computed: {
      getActive() {
        return this.active !== null ? this.active : this.element.active 
      }
    },
    props: {
        element: {
            type: Object,
            required: true
        }
    },
    methods: {
      changeFilter () {
        this.active = !this.active;
        this.element.active = !this.element.active;
        this.$emit('changeSports', this.element)
      }
    }
}
</script>